module.exports = __webpack_public_path__ + "img/sad-emoji.7da487b1.png";